/**
 * Collection Item
 */
class CollectionResult extends CollectionItem {

	/**
	 * Thumbnail image container
	 * @private
	 */
	private imageEl: HTMLImageElement;

	/**
	 * ACL Button
	 * @private
	 */
	private aclBtnEl: HTMLElement;

	/**
	 *
	 * @private
	 */
	private numHitsEl: HTMLElement;

	/**
	 *
	 * @param item
	 * @param clickFn
	 * @param viewType
	 */
	constructor(item: {title: string, thumbnail: string, mediaType: string, description: string, creationDate?: string,
					modifiedDate?: string, owner?: string, numHits?: number, fileSize?: number, totalDuration?: string,
					id?: number, acl?: Array<any>, aclBtn?: string, isPublic?: boolean, isShared?: boolean, isPrivate?: boolean,
					hasVideoWorkflow?: boolean, hasAudioWorkflow?: boolean, showOrder?: boolean, showOrderFor?: boolean, showOrderOnBehalfOf?: boolean, collectionMediaTypes: Array<string>, canView?: boolean},
				clickFn: () => void,
				viewType: number) {
		super(item, clickFn, viewType);

		if (this.smartId) {
			this.getSmartDetails();
		}
	}

	/**
	 *
	 */
	view() {
		this.mainContainer.id = 'collection-tile-' + this.id;
		switch (this.viewType) {
			case ViewType.list:
				this.listView();
				this.mainContainer.className = 'overview-tile-item';

				if (this.description.length !== 0 || null) {
					this.mainContainer.className = 'overview-tile-item overview-tile-item--desc';
				}
				break;

			case ViewType.grid:
				this.mainContainer.className = 'overview-tile';
				this.gridView();
				break;
		}
	}

	/**
	 * Render the ACL button
	 * @param view
	 */
	private renderACLBtn(view: string): ChildNode {
		let btnParent = document.createElement('p'),
			res: any = null;

		if (typeof this.aclBtn === 'string' && this.aclBtn.length === 0) {
			let el = iwUI.createEl('BUTTON', {class: 'btn btn--mini is-disabled'}),
				icon = iwUI.createEl('I', {}),
				txt = iwUI.createEl('SPAN', {class: 'acl_update_link_text'});

			switch(true) {
				case this.isPrivate:
					icon.classList.add('iw-icon-padlock');
					txt.textContent = iwi18n.gettext('collections', 'Private');
					el.classList.add('overview__aclBtn--private');
					break;
				case this.isShared:
					icon.classList.add('iw-icon-public');
					txt.textContent = iwi18n.gettext('collections', 'Shared');
					el.classList.add('overview__aclBtn--shared');
					break;
				case this.isPublic:
					icon.classList.add('iw-icon-unlock');
					txt.textContent = iwi18n.gettext('collections', 'Public');
					el.classList.add('overview__aclBtn--public');
					break;
				default:
					break;
			}

			el.append(icon, txt);
			res = el;
			res.classList.add('overview__aclBtn');
		} else if (typeof this.aclBtn === 'string' && this.aclBtn.length > 0) {
			iwCore.appendHTML(this.aclBtn, btnParent);
			res = btnParent.firstChild;
			res.classList.add('overview__aclBtn');
		}


		switch(view) {
			case 'list':
				res.classList.add('overview__aclBtn--list');
				break;
			case 'grid':
				res.classList.add('overview__aclBtn--grid');
				break;
			default:
				break;
		}

		return res;
	}

	/**
	 *
	 */
	private createCtx() {
		return iwMenu.createMenuLink('collectionCtx', CollectionsViewer.getCollectionCtxParams(this, true));
	}

	/**
	 * Creating the list view
	 */
	private listView() {
		this.imageEl = iwUI.createEl('img', {src: '', class: 'overview-item-img'});

		let imageWrap = iwUI.createEl('div', {class: 'overview-item-imgWrap'}),
			info = iwUI.createEl('div', {class: 'overview-item-info'}),
			title = iwUI.createEl('p', {class: 'overview-item-title'}),
			titleWrap = iwUI.createEl('div', {class: 'overview-item-dataWrap overview-item-dataWrap--title'}),
			desc = iwUI.createEl('p', {class: 'overview-item-data overview-item-data--desc'}),
			dateWrap  = iwUI.createEl('div', {class: 'overview-item-dataWrap overview-item-dataWrap--date'}),
			aclBtn = this.renderACLBtn('list'),
			detailsWrap = iwUI.createEl('div', {class: 'overview-item-dataWrap overview-item-dataWrap--details'}),
			avatar = iwUI.createEl('div', {class: 'owner-icon owner-icon--list'}),
			imgAlt = iwi18n.gettext('collections', '%1 image - %2', iw.collectionsName, this.title),
			ctx = this.createCtx();

		this.imageEl.setAttribute('alt', imgAlt);
		this.imageEl.src = this.thumbnail ?? '';
		desc.textContent = this.description;
		title.textContent = this.title;

		avatar.textContent = this.owner.slice(0, 2).toUpperCase();
		avatar.setAttribute('data-tool-tip', this.owner);
		avatar.classList.add('iw_tool_tip_link');
		if (avatar.textContent === '') {
			avatar.classList.add('is-empty');
		}

		EVENT.attach(avatar, 'click', (e: MouseEvent) => {
			iwCore.copyToClipboard(this.owner);
			iwNotifications.alert(iwi18n.gettext(undefined, "Creators email copied to your clipboard"), 'Copy');
			e.preventDefault();
			e.stopPropagation();
		});

		imageWrap.appendChild(this.imageEl);
		this.imageEl.src = iwUI.imageFallback(this.mediaType, this.thumbnail);
		this.imageEl.setAttribute('onerror', `this.src='${iwUI.imageFallback(this.mediaType, '')}'`);

		EVENT.attach(this.mainContainer, 'click', this.clickFn);

		titleWrap.append(title);
		dateWrap.append( this.detailsUI('Created:', this.creationDate), this.detailsUI('Edited:', this.modifiedDate));

		if (this.numHits > -1) {
			this.numHitsEl = this.detailsUI('items', this.numHits);
			detailsWrap.append(this.numHitsEl);
			info.append(aclBtn, titleWrap, dateWrap, detailsWrap);

			if (this.totalDuration) {
				detailsWrap.append(this.detailsUI('duration', this.totalDuration));
			}

			if (this.fileSize && this.fileSize.split(' ')[0] !== '0') {
				detailsWrap.append(this.detailsUI('fileSize', this.fileSize));
			}
		}

		if (this.description.length !== 0 || null) {
			titleWrap.append(desc);
		}

		this.mainContainer.append(avatar, imageWrap, info, ctx);
	}

	/**
	 * Create the avatar
	 * @private
	 */
	private makeAvatar() {
		let avatar = iwUI.createEl('div', {class: 'owner-icon owner-icon--overview'}),
			avatarText = iwUI.createEl('span', {class: 'owner-icon-txt'});

		// Only show owner initials and tooltip, if collection owner is not empty
		if(this.owner !== "") {
			avatarText.textContent = this.owner.slice(0, 2).toUpperCase();
			avatarText.setAttribute('data-tool-tip', this.owner);
			avatarText.classList.add('iw_tool_tip_link');
		} else {
			avatar.classList.add('is-empty');
		}

		EVENT.attach(avatar, 'click', () => {
			iwCore.copyToClipboard(this.owner);
			iwNotifications.alert(iwi18n.gettext(undefined, "Creators email copied to your clipboard"), 'Copy');
		});

		avatar.append(avatarText);
		return avatar
	}

	/**
	 * Creating the grid view
	 */
	private gridView() {
		this.imageEl = iwUI.createEl('img', {src: '', class: 'overview-tile-img'});
		let title = iwUI.createEl('h2', {class: 'overview-tile-title'}),
			datesWrap = iwUI.createEl('DIV', {class: 'overview-tile-datesWrap'}),
			detailsWrap = iwUI.createEl('DIV', {class: 'overview-tile-detailsWrap'}),
			createdWrap = iwUI.createEl('DIV', {class: 'overview-tile-dateWrap overview-tile-dateWrap--created'}),
			editedWrap = iwUI.createEl('DIV', {class: 'overview-tile-dateWrap overview-tile-dateWrap--edited'}),
			createdLabel = iwUI.createEl('SPAN',	{class: 'overview-date-label'}),
			dateCreated = iwUI.createEl('TIME',	{class: 'overview-tile-date'}),
			editedLabel =  iwUI.createEl('span', {class: 'overview-date-label'}),
			dateModified = iwUI.createEl('TIME', {class: 'overview-tile-edit'}),
			desc = iwUI.createEl('p', {class: 'overview-tile-desc'}),
			avatar = this.makeAvatar(),
			tileInfo = iwUI.createEl('div', {class: 'overview-tile-info'}),
			aclBtn = this.renderACLBtn('grid'),
			tileExpand = iwUI.createEl('div', {class: 'overview-tile-expand iwSlideSection', id: 'overview-expand-' + this.id}),
			imgAlt = iwi18n.gettext('collections', '%1 image - %2', iw.collectionsName, this.title),
			ctx = this.createCtx(),
			showDesc = false;

		/**
		 * Translate tile contents, on the same amount of pixels as the tileExpand height
		 */
		let expandContents = () => {
			let height = tileExpand.scrollHeight;

			if (!showDesc) {
				this.mainContainer.classList.add('is-expanded');
				this.imageEl.style.transform = `translateY(-${height}px)`;
				tileInfo.style.transform = `translateY(-${height}px)`;
				avatar.style.transform = `translateY(-${height}px)`;
				showDesc = true;
			} else {
				if(this.mainContainer.classList.contains('is-expanded')) {
					this.mainContainer.classList.remove('is-expanded');
				}
				this.imageEl.style.transform = 'translateY(0)';
				tileInfo.style.transform = 'translateY(0)';
				avatar.style.transform = 'translateY(0)';
				showDesc = false;
			}
		}

		this.imageEl.setAttribute('alt', imgAlt);
		desc.textContent = this.description;
		title.textContent = this.title;
		createdLabel.textContent = iwi18n.gettext('collections', 'Created:');
		editedLabel.textContent = iwi18n.gettext('collections', 'Edited:');
		dateCreated.textContent = ` ${this.creationDate}`;
		dateCreated.setAttribute('datetime', this.creationDate);
		dateModified.textContent = ` ${this.modifiedDate}`;
		dateModified.setAttribute('datetime', this.modifiedDate);
		createdWrap.append(createdLabel, dateCreated);
		editedWrap.append(editedLabel, dateModified);
		datesWrap.append(createdWrap, editedWrap);

		if (this.numHits > -1) {
			this.numHitsEl = this.detailsUI('items', this.numHits);
			detailsWrap.append(this.numHitsEl);

			if (this.totalDuration) {
				detailsWrap.append(this.detailsUI('duration', this.totalDuration));
			}

			if (this.fileSize && this.fileSize.split(' ')[0] !== '0') {
				detailsWrap.append(this.detailsUI('fileSize', this.fileSize));
			}
		}

		this.imageEl.src = iwUI.imageFallback(this.mediaType, this.thumbnail);
		this.imageEl.setAttribute('onerror', `this.src='${iwUI.imageFallback(this.mediaType, '')}'`);

		EVENT.attach(this.imageEl, 'click', this.clickFn);

		if (this.description.length !== 0 || null) {
			const expandIcon = iwUI.createEl('I', {class: 'expand-icon iw-icon-down'});
			expandIcon.setAttribute('aria-label', iwi18n.gettext('collections', 'Expand %1 description', iw.collectionsName));
			title.setAttribute('role', 'button');
			title.appendChild(expandIcon);

			this.mainContainer.classList.add('overview-tile--desc');
			iwCore.toggleClassName(this.mainContainer, 'overview-tile--desc')

			EVENT.attach(tileInfo, 'click', () => {
				iwCore.slideElement('overview-expand-' + this.id, dateCreated);
				expandContents();
			});

			tileExpand.appendChild(desc);
			tileInfo.append(aclBtn, title, tileExpand, datesWrap, detailsWrap);
		} else {
			tileInfo.append(aclBtn, title, datesWrap, detailsWrap);
		}

		this.mainContainer.append(this.imageEl, ctx, avatar, tileInfo);
	}

	/**
	 * Get the thumbnail and numhits of a smart collection
	 * @private
	 */
	private getSmartDetails() {
		iwCore.ajax({
			url: '/collections/getsmartdetails',
			type: 'GET',
			data: {
				id: this.id,
				smartId: this.smartId,
			},
			success: (e: any) => {
				if (e.success) {
					this.numHits = e.data.numHits ?? 0;
					this.thumbnail = e.data.thumbnail ?? '';

					if (this.thumbnail) {
						this.imageEl.src = this.thumbnail;
					}

					this.numHitsEl.replaceWith(this.detailsUI('items', this.numHits));
				}
			}
		})
	}

	/**
	 * UI elements
	 * @private
	 */
	private detailsUI(type: string, data: string | number) {
		let wrap: HTMLElement = iwUI.createEl('DIV', {class: 'overview-detail-wrap'}),
			icon: HTMLElement = iwUI.createEl('I', {class: 'overview-tile-itemsIcon'}),
			el: HTMLElement = iwUI.createEl('SPAN', {class: 'overview-tile-typeTitle'}),
			label: HTMLElement = null;

		wrap.classList.add('iw_tool_tip_link');

		switch(type) {
			case 'items':
				wrap.classList.add('overview-tile-itemsWrap');
				wrap.setAttribute('aria-label', iwi18n.gettext('collections', 'Number of items in %1', iw.collectionsName));
				wrap.setAttribute('data-tool-tip', iwi18n.gettext('collections', 'Number of items in %1', iw.collectionsName));
				icon.classList.add('iw-icon-multiple-media');
				break;
			case 'fileSize':
				wrap.classList.add('overview-tile-fileSizeWrap');
				wrap.setAttribute('aria-label', iwi18n.gettext('collections', 'File size'));
				wrap.setAttribute('data-tool-tip', iwi18n.gettext('collections', 'File size'));
				icon.classList.add('iw-icon-document');
				break;
			case 'duration':
				wrap.classList.add('overview-tile-durationWrap');
				wrap.setAttribute('aria-label', iwi18n.gettext('collections', 'Duration'));
				wrap.setAttribute('data-tool-tip', iwi18n.gettext('collections', 'Duration'));
				icon.classList.add('iw-icon-clock');
				break;
			default:
				label = iwUI.createEl('SPAN', {class: 'overview-tile-dateLabel'});
				label.textContent = `${iwi18n.gettext('collections', type)} `;
		}

		el.textContent = data.toString();

		if(type === 'items' || type === 'fileSize' || type === 'duration') {
			wrap.append(icon, el);
		} else {
			wrap.append(label, el);
		}

		return wrap;
	}
}